<template>
  <div
    v-if="element"
    :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{
      ...getStyles({
        ...element.compData.styles
      })
    }"
    style="width: 100%; height: 100%"
  >
    <div
      :class="
        'check-box' +
          (element.compData.checkBoxBorder == 'true' ? ' checkBoxBorder' : '')
      "
    >
      <div
        v-if="element.compData.textPosition"
        class="check-box-left"
        @click="handleClick($event, element)"
      >
        <Checkbox
          :size="element.compData.size"
          :value="element.compData.single"
        ></Checkbox>
        <span class="check-text">{{ element.compData.text }}</span>
      </div>
      <div class="check-box-right" v-else @click="handleClick($event, element)">
        <span class="check-text">{{ element.compData.text }}</span>
        <Checkbox
          :size="element.compData.size"
          :value="element.compData.single"
        ></Checkbox>
      </div>
    </div>
  </div>
</template>

<script>
// iview
import { Checkbox } from "view-design";
import "view-design/dist/styles/iview.css";

export default {
  name: "CompCheckBox",
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {
    Checkbox
  },
  data: () => {
    return {
      loading: true
    };
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id);
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1234);
    this.$blueMap.trigger({
      nodeType: "plugin",
      pluginId: this.element.id,
      dataKey: "onmounted",
      eventData: {
        value: this.element.compData,
        data: this.plugin,
        event: null
      }
    });
  },
  methods: {
    handleClick(ev) {
      ev.stopPropagation();
      this.element.compData.single = !this.element.compData.single;
      this.triggerEventType();
    },
    triggerEventType() {
      if (
        this.element &&
        this.element.compData &&
        this.element.compData.single
      ) {
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.element.id,
          dataKey: "onChecked",
          eventData: {
            value: this.element.compData,
            data: this.plugin,
            event: null
          }
        });
      } else {
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.element.id,
          dataKey: "unChecked",
          eventData: {
            value: this.element.compData,
            data: this.plugin,
            event: null
          }
        });
      }
    },
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach(item => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return res;
    }
  }
};
</script>

<style lang="less" scoped>
//复选框组件样式开始
.check-box {
  width: 100%;
  height: 100%;
  padding: 0 var(--paddingRight);
  cursor: pointer;
  // line-height: var( --FontSize);
  .check-box-left {
    width: 100%;
    height: 100%;
    /deep/ .ivu-checkbox-wrapper {
      position: absolute;
      top: 50%;
      // left:0;
      transform: translateY(-50%);
    }
    .check-text {
      width: calc(100% - (30px + 2 * var(--paddingRight)));
      font-size: var(--FontSize);
      font-family: var(--fontFamily) !important;
      position: absolute;
      top: 50%;
      right: var(--paddingRight);
      transform: translateY(-50%);
      color: var(--FontColor);
      text-align: right;
      overflow: hidden;
    }
  }
  .check-box-right {
    width: 100%;
    height: 100%;
    /deep/ .ivu-checkbox-wrapper {
      position: absolute;
      top: 50%;
      right: var(--paddingRight);
      transform: translateY(-50%);
    }
    .check-text {
      width: calc(100% - (30px + 2 * var(--paddingRight)));
      font-size: var(--FontSize);
      font-family: var(--fontFamily) !important;
      position: absolute;
      top: 50%;
      left: var(--paddingRight);
      transform: translateY(-50%);
      color: var(--FontColor);
      text-align: left;
      overflow: hidden;
    }
  }
}
.checkBoxBorder {
  border: var(--borderWidth) solid var(--borderColor);
  // position: absolute;
}
/deep/ .ivu-checkbox-inner {
  border: 0;
  background-color: rgba(161, 161, 161, 1);
}
/deep/ .ivu-checkbox-checked {
  .ivu-checkbox-inner {
    border-color: var(--bgColor);
    background-color: var(--bgColor);
  }
}
//复选框样式结束
</style>
